<template>
  <div class="dataBox">
    <el-table
      :data="signContractTipData"
      style="width: 100%;margin-bottom:10px;"
      border
      header-cell-class-name="cellCustomer headerCellCustomer ft14"
      cell-class-name="cellCustomer ft12"
    >
      <template slot="empty">
          <img class="data-pic" src="../../../../../assets/images/H5/null.png" alt="" />
          <br/>
          暂无数据
      </template>
      <el-table-column prop="code" label="合同编号"></el-table-column>
      <el-table-column prop="name" label="合同名称"></el-table-column>
      <el-table-column label="发起方">
        <template slot-scope="scope">
          <span>{{scope.row&&scope.row.contractUser&&scope.row.contractUser.name}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="creditAssignee" label="委托方"></el-table-column>
      <el-table-column prop="signStartTime" label="发起时间"></el-table-column>
      <el-table-column prop="signFinishTime" label="签署完成时间"></el-table-column>
      <el-table-column label="操作" width="257px">
        <template slot-scope="scope">
          <div class="handlerBoxCenter">
              <div class="cursorPointer"  v-if="scope.row.signStatus == 2 && ((scope.row.type==2 && getUserInfo.currentUserId != scope.row.contractUser.userId ) || (scope.row.type==4 && scope.row.signatoryRoleCode == 'DR')) ">
               <el-popover
                    popper-class="CompleteSign_popper"
                    placement="bottom"
                    width="154"
                    trigger="hover">
                    <!-- <div class="notratType" v-if="scope.row.type==1 || scope.row.type==2 && getUserInfo.currentUserId == scope.row.contractUser.userId">
                      <p @click="addNotrat(scope.row)">普通公证</p>
                    </div> -->
                    <div class="notratType" v-if="scope.row.type==2 && getUserInfo.currentUserId != scope.row.contractUser.userId">
                       <!-- <p @click="addNotrat(scope.row)">普通公证</p> -->
                       <p @click="addNotrats(scope.row)">贷款赋强公证</p>
                    </div>
                 <div class="notratType" v-if=" scope.row.type==4 && scope.row.signatoryRoleCode == 'DR'">
                   <!-- <p @click="addNotrat(scope.row)">普通公证</p> -->
                   <p @click="addNotrats(scope.row)">调解赋强公证</p>
                 </div>
                    <span  class="iconDscp" slot="reference">申请公证</span>
                  </el-popover>
              <!-- <span class="icon"></span> -->
            </div>
            <div class="cursorPointer download" @click="toLoad(scope.row)">
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">下载</span>
            </div>
            <div class="cursorPointer download"
              @click="onReSign(scope.row)"
              v-if="scope.row.canReSign">
              <span class="iconDscp">重新签</span>
            </div>
            <div class="cursorPointer " @click="toDetail(scope.row)">
              <!-- <span class="icon"></span> -->
              <span class="iconDscp">详情</span>
            </div>
            <div class="cursorPointer" @click="toCreatFqPerformance(scope.row)" v-if="scope.row.performTask == 1">
              <span class="iconDscp">发起履约</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <Dialog
        :visible="applyNotar"
        :dialogTitle="'申请公证'"
        v-on:closeDialog="closeDialog"
        :width="'600px'"
      >
        <div slot="dialog">
          <div class="applyNotar">
            <apply
              @closeDialog="closeDialog"
              :curnotar="curnotar"
              ref="multiples"
              @applyNotar="applyNotarFn"
            ></apply>
          </div>
        </div>
      </Dialog>
      <Dialog
        :visible="applyNotars"
        :dialogTitle="'赋强公证'"
        v-on:closeDialog="closeDialogs"
        :width="'500px'"
      >
        <div slot="dialog">
          <div class="applyNotars">
            <div class="rlsbs wxapp-con">
              <p class="rlsb_desc">
                微信扫码在小程序完成赋强公证
              </p>
              <p class="rlsb_title">&nbsp;− 二维码5分钟内有效 −&nbsp;</p> 
              <div class="erweima wxappCode">
                <!-- <vue-qr id="canvass" :text="codrUrl" :size="200"></vue-qr> -->
                <img :src="codrUrl"/>
              </div>
              <div class="erweima_errro wxapperror" v-show="error_erweima && status==1">
                <p class="error_title">二维码失效</p>
                <span class="update_erweima" @click="updateEr">点击刷新</span>
              </div>
              <div class="erweima_success wxappsuccess"  v-show="status==0">
                <img src="../../../../../assets/images/userHome/wxsmcg_icon.png"/>
                <p class="success_title">扫描成功</p>
                <p class="success_desc">请在手机端完成申请公证</p>
                <!-- <span class="success_update_erweima" @click="updateEr">点击刷新</span> -->
              </div>
              <!-- <div class="erweima_success" v-show="(status==1||status==2) && codeStatus!=0">
                <img src="../../../../../assets/images/userHome/wxsmcg_icon.png"/>
                <p class="success_title">扫描成功</p>
                <p class="success_desc">请在手机端完成申请公证</p>
                <span class="success_update_erweima" @click="updateEr">点击刷新</span>
              </div>
              <div class="erweima_success" v-show="codeStatus==0">
                <img src="../../../../../assets/images/userHome/wxsmcg_iconS.png"/>
                <p class="success_title">已完成申请公证</p>
              </div> -->
              
              <!-- <button class="success_face" type="button" v-show="status==1||status==2"  @click="getFaceResult">已完成申请公证</button> -->
                <!-- <button class="error_face" type="button">未完成人脸验证</button> -->
            </div>
          </div>
        </div>
      </Dialog>
  </div>
</template>
<script>
import Dialog from "@common/Dialog.vue";
import apply from "../../../service/components/applyNotar.vue";
import BaseApi from "@lib/baseApi.js";
import vueQr from "vue-qr";
import {mapGetters} from "vuex";
export default {
  data() {
    return {
      signContractTipData: [],
      applyNotar:false,
      applyNotars:false,
      codrUrl:"",
      status:1,//二维码状态
      codeStatus:null,//认证状态
      error_num:false,
        //二维码扫描成功
      success_erweima:false,
      //二维码失效
      error_erweima:false,
      isshowTimeEnd:false,
      text:"",
      curnotar:{}
    };
  },
  components: {
    Dialog,
    apply,
    vueQr
  },
  mounted() {},
   computed:{
    ...mapGetters(['getUserInfo','getCurInfo'])
  },
  methods: {
    setData(data) {
      this.signContractTipData = data;
    },
    toDetail(row) {
      this.$emit("toDetail", row);
    },
    onReSign(row) {
      this.$emit("toReSign", { data: row });
    },
    toCreatFqPerformance(row) {
      this.$emit("toCreatFqPerformance", row);
    },
    toLoad(row) {
      this.$emit("toLoad", row);
    },
    closeDialog(){
      this.applyNotar=false;
    },
    closeDialogs(){
      this.applyNotars=false;
    },
    //普通公证
    addNotrat(data){
      this.curnotar=data;
      this.applyNotar=true;
    },
    //实时获取二维码状态
    setTimerEr(contractId) {
      var timer=null;
      BaseApi.createRpcToken("/notaryApply/getWxUrlStatus",{contractId},"GET").then(data=>{
        if(data.code==200){
            clearTimeout(timer)
            this.status=data.datas.status;
            let self=this;
            if (self && !self._isDestroyed) {
              timer = setTimeout(() => {
                this.setTimerEr(contractId)
              }, 1000)  
            }
             if(this.isshowTimeEnd && data.datas.status!=0){
               clearTimeout(timer)
            }else
            //二维码失效
            if(this.error_erweima){
              clearTimeout(timer)
            }else if(data.datas.status==0){//扫码完成
               clearTimeout(timer)
            }
        }
      else {
          clearTimeout(timer) //清理定时任务
      }
      }, data => {
        
      })
      .catch(function (e) {
        errorLog(e);
      });
    },      
 
    //赋强公证
    addNotrats(info){
      this.infoData=info
      this.$store.commit('showLoading',true)
      BaseApi.createRpcToken(
        "/notaryApply/checkCanFqNotaryApply",
        {
          contractId: info.id,
          notaryId: 1,
        },
        "post"
      )
        .then(data => {
          this.$store.commit('showLoading',false)
          var  timer=null;
            var endTime = new Date().getTime()+5*60*1000;
              timer=setInterval(()=>{
                var start =  new Date().getTime();
                if(start > endTime){
                  this.isshowTimeEnd=true;
                  this.error_erweima=true;
                  clearInterval(timer)
                }else{
                  if(this.status==0){
                    clearInterval(timer)
                    this.isshowTimeEnd=false; 
                    this.error_erweima=false;
                  }else{
                    this.error_erweima=false;
                  }
                }
              },1000)
          if (data.datas.code==200) {
            // let bytes = new Uint8Array(window.btoa(datat));
            // let datat = "";
            // console.log(bytes)
            // let len = bytes.byteLength;
            // for (let i = 0; i < len; i++) {
            //   datat += String.fromCharCode(bytes[i]);
            // }
            // console.log(datat)
            // console.log(window.btoa(datat))
            this.codrUrl = "data:image/png;base64,"+ data.datas.wxUrlbase64;
              this.applyNotars=true;
              this.setTimerEr(info.id);
          } else {
            this.$message.error(data.datas.message);
          }
        })
        .catch(function(e) {
          errorLog(e);
        });
    },
    getFaceResult(){

    },
    applyNotarFn(data){
      console.log(data)
    },
    //刷新二维码
    updateEr(){
      if(this.codeStatus==0){
        return;
      }else{
        this.error_erweima=false;
      }
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.CompleteSign_popper{
  width: 157px !important;
  box-sizing: border-box;
  height: auto !important;
  padding: 7px 0px;
}
.notratType{
  p{
    padding: 0px 12px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    font-weight: 400;
    color: #2B2B2B;
    cursor: pointer;
    &:hover{
      background: #e88078;
      color: #fff;
    }
  }
}

.rlsbs{
  width: 100%;
  height: 300px;
  position: relative;
  .erweima_errro{
    width:160px;
    height:160px;
    background:rgba(255,255,255,0.78);
    position: absolute;
    top: 38px;
    left: 50%;
    margin-left:-80px;
    z-index: 99;
    text-align: center;
    padding-top: 60px;
    box-sizing: border-box;
    .error_title{
      font-size:16px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:600;
      color:rgba(50,50,50,1);
      margin-bottom: 12px;
    }
    .update_erweima{
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:#000;
      cursor: pointer;
    }
  }
  .erweima_success{
     width:160px;
    height:160px;
    background:rgba(255,255,255,0.78);
    position: absolute;
    top: 60px;
    left: 50%;
    margin-left:-80px;
    z-index: 99;
    text-align: center;
    padding-top: 35px;
    box-sizing: border-box;
    .success_desc{
      margin-bottom: 10px;
      margin-top: 3px;
      font-size: 13px;
    }
    .success_title{
       font-size:16px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:600;
      color:rgba(50,50,50,1);
      margin-top: -4px;
    }
     .success_update_erweima{
      font-size:14px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(77,175,247,1);
      cursor: pointer;
    }
    img{
      opacity: 1;
    }
  }
  .rlsb_title{
    color: #1890FF;
    margin: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    span{
      display: inline-block;
      width: 8px;
      height: 1px;
      background: #1890FF;
      border:0;
    }
  }
  .erweima{
    width: 160px;
    margin: 0 auto;
    height: 160px;
    img{
      width: 100%;
    }
  }
  .rlsb_desc{
    width: 100%;
    text-align: center;
    height: 30px;
    line-height: 30px;
    margin-top: 20px;
  }
  .success_face{
    width: 183px;
    height: 40px;
    background: #D81212;
    border: 1px solid #D81212;
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    display: block;
    margin: 0 auto;
  }
}
</style>
